import './assets/less/main.less'
import 'virtual:uno.css'
import '@unocss/reset/normalize.css'
import '@varlet/ui/es/style'

import App from './App.vue'
import router from './router'
import Varlet from '@varlet/ui'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import '@varlet/touch-emulator'
import VConsole from 'vconsole'
import './utils/resetFastClick'
import './permission'
const vconsole = new URLSearchParams(window.location.search).get('vconsole')
const vConsole = vconsole === '1' ? new VConsole() : ''

const app = createApp(App)

app.use(router).use(createPinia()).use(Varlet)
.mount('#app')
